import { render } from "./SottoProgettoDettaglioFornitore.vue?vue&type=template&id=30c1f344&ts=true"
import script from "./SottoProgettoDettaglioFornitore.vue?vue&type=script&lang=ts"
export * from "./SottoProgettoDettaglioFornitore.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__